class Weglot {
  key: string
  endpoint: string

  constructor(config: Record<string, string>) {
    this.key = config.key
    this.endpoint = config.endpoint
  }

  async execute() {
    try {
      if ('Weglot' in window) {
        window.Weglot.initialize({
          api_key: this.key,
          hide_switcher: true,
        })
        this.initWaiting()
      } else {
        console.error('Error: Weglot not in window before initialization')
      }
    } catch (error) {
      throw new Error(`Weglot execute ${error}`)
    }
  }

  initWaiting = () => {
    const delay = 500
    let attempts = 0
    const attemptsMax = 10
    const weglotCheck = setInterval(() => {
      if (attempts === attemptsMax) clearInterval(weglotCheck)
      if (window.Weglot.initialized) {
        clearInterval(weglotCheck)
        this.switcher()
      } else {
        console.debug('Waiting for Weglot init... ', attempts)
        attempts++
      }
    }, delay)
  }

  switcher() {
    console.debug('Weglot event: initialized')

    if (!window.Weglot) {
      console.error('Error: Weglot not in window after initialization')
      return
    }

    const options = window.Weglot.options.languages
    const availableLanguages = options
      .map(function (language) {
        return language.language_to
      })
      .concat(window.Weglot.options.language_from)

    const availableLinks = options
      .map(function (language) {
        return language.connect_host_destination.host
      })
      .concat('compass.info')

    const switchers = document.querySelectorAll('.language-switcher')
    const urlPath = window.location.pathname

    switchers.forEach((switcher) => {
      const currentLang = window.Weglot.getCurrentLang()
      const toggle = switcher.querySelector('.switch')
      const list = switcher.querySelector('.list')
      const title = document.createElement('span')
      const shortTitle = document.createElement('span')
      shortTitle.className = 'short'
      const langName = window.Weglot.getLanguageName(currentLang)

      title.innerHTML = langName
      shortTitle.innerHTML = currentLang

      toggle.prepend(title, shortTitle)

      for (let i = 0; i < availableLanguages.length; i++) {
        const lang = availableLanguages[i]

        if (lang !== currentLang) {
          const link = document.createElement('a')
          const title = document.createElement('span')
          const langName = window.Weglot.getLanguageName(lang)

          link.href = 'https://' + availableLinks[i] + urlPath
          title.innerHTML = langName
          link.append(title)
          list.appendChild(link)
        }
      }
    })
  }
}

export default defineNuxtPlugin(() => {
  const {
    public: { weglot },
  } = useRuntimeConfig()

  if (!weglot.key || !weglot.endpoint) {
    return
  }

  useHead({
    script: [
      {
        src: weglot.endpoint,
        defer: true,
        async: true,
        onload: () => new Weglot(weglot).execute(),
        onerror: (error) =>
          console.error(`Failed to load Weglot script: ${error}`),
      },
    ],
  })
})
